exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.md-select-clear-selection[data-v-2b825f2e] {\n  margin: 0;\n  padding: 0;\n}\n.clear-icon-size[data-v-2b825f2e] {\n  width: 16px;\n  min-width: 16px;\n  height: 16px;\n  font-size: 16px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b825f2e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/common/fields/SelectField3.vue
// module id = Wn/R
// module chunks = 1